export default {
  add: {
    method: 'post',
    url: '/ws-admincp/node/location'
  },
  list: {
    method: 'post',
    url: '/ws-admincp/node/location/list'
  },
  detail: {
    method: 'get',
    url: '/ws-admincp/node/location/ID'
  },
  edit: {
    method: 'put',
    url: '/ws-admincp/node/location/ID'
  },
  delete: {
    method: 'delete',
    url: '/ws-admincp/node/location'
  },
  archive: {
    method: 'delete',
    url: '/ws-admincp/node/location/archive'
  },
  restore: {
    method: 'put',
    url: '/ws-admincp/node/location/restore'
  },
  getAll: {
    method: 'get',
    url: '/ws-admincp/node/location/get-all'
  },
  find: {
    method: 'get',
    url: '/ws-admincp/node/location/finds?key=KEY'
  }
}
